<script>
  export let color = 'rgb(90, 95, 109)'
  export let size = '32px'
</script>

<i 
  class="icon-spin5"
  style:color
  style:font-size={`${size}px`}
/>

<style lang="scss">
  .icon-spin5::before {
    animation: rotation 2s linear infinite;

    @media (max-width: 576px) {
      margin: 15px 0;
    }
  }
</style>